import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * Service d'appel à l'API back.
 * Gère l'authentification et l'identifiant de corrélation
 * @publicApi
 */
@Injectable({
  providedIn: 'root'
})
export class AppelapiService {

  // URL ajoutée devant les urls passées aux méthodes.
  // public pour faciliter les tests unitaires
  private baseUrl: string;

  public ContentType: string;
  /*private headerCle = {
    name: environment.apiPortailAchat.headerCleApi,
    value: environment.apiPortailAchat.valeurCleApi
  }*/

  constructor(private http: HttpClient) {
    this.baseUrl = environment.lien.api.baseUrl;
    this.ContentType = 'application/json'
  }

  get<T>(url: string, otherBaseUrl?: string, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  }, searchParams?: URLSearchParams): Observable<T> {

    if (searchParams) {
      url = url.concat('?' + searchParams.toString());
    }

    if (otherBaseUrl) {
      return this.http.get<T>(otherBaseUrl + url, this.enrichirOptions(options));
    } else {
      return this.http.get<T>(this.baseUrl + url, this.enrichirOptions(options));
    }
  }

  patch<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  }): Observable<T> {
    return this.http.patch<T>(this.baseUrl + url, body, this.enrichirOptions(options));
  }

  post<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  }): Observable<T> {
    return this.http.post<T>(this.baseUrl + url, body, this.enrichirOptions(options));
  }

  put<T>(url: string, body: any | null, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  }): Observable<T> {
    return this.http.put<T>(this.baseUrl + url, body, this.enrichirOptions(options));
  }

  delete<T>(url: string, options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  }): Observable<any> {

    return this.http.delete(this.baseUrl + url, this.enrichirOptions(options));
  }

  enrichirOptions(options?: {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  }): {
    headers?: HttpHeaders | {
      [header: string]: string | string[];
    };
    params?: HttpParams | {
      [param: string]: string | string[];
    };
  } {
    // crée une instance réelle d'options
    const optionsReelles = options ?? {}

    // normalise les headers, sous forme de HttpHeaders, pour pouvoir ajouter des headers
    let headers: HttpHeaders = new HttpHeaders();
    if (optionsReelles && optionsReelles.headers) {
      if (optionsReelles.headers instanceof HttpHeaders) {
        headers = optionsReelles.headers;
      }
      else {
        headers = new HttpHeaders(optionsReelles.headers);
      }
    }

    // normalise les headers, sous forme de HttpHeaders, pour pouvoir ajouter des headers
    let params: HttpParams = new HttpParams();
    if (optionsReelles && optionsReelles.params) {
      if (optionsReelles.params instanceof HttpParams) {
        params = optionsReelles.params;
      }
      else {
        params = new HttpParams(optionsReelles.params);
      }
    }

    // Ajout des En-têtes.
    optionsReelles.headers = headers;
    optionsReelles.params = params;
    return optionsReelles;
  }
}
